import { cx } from "../../lib/cx.js";
/* empty css           */
import { jsx } from "react/jsx-runtime";
//#region src/components/Layout/Layout.tsx
var SPACES = /* @__PURE__ */ new Set([
	0,
	1,
	2,
	3,
	4,
	5,
	6,
	8,
	10,
	12,
	16,
	24
]);
/** `var(--space-N)`, or undefined (the pack's default gap) for a key not on the scale. */
function spaceVar(space) {
	return space !== void 0 && SPACES.has(space) ? `var(--space-${space})` : void 0;
}
/**
* Children one under another, a token gap apart: a one-column grid, each child
* stretched to the Stack's width. The default gap is the pack's `--stack-gap` (24px in
* LEADSPPLY).
*/
function Stack({ gap, align = "stretch", justify, measure, shrink = false, as: Element = "div", className, style, ...rest }) {
	return /* @__PURE__ */ jsx(Element, {
		...rest,
		className: cx("ds-stack", `ds-layout--align-${align}`, justify && `ds-layout--justify-${justify}`, measure && `ds-stack--measure-${measure}`, shrink && "ds-stack--shrink", className),
		style: {
			gap: spaceVar(gap),
			...style
		}
	});
}
/**
* Children side by side, a token gap apart, wrapping when the row is full. The default
* gap is the pack's `--inline-gap` (16px in LEADSPPLY).
*/
function Inline({ gap, rowGap, align = "center", justify = "start", wrap = true, as: Element = "div", className, style, ...rest }) {
	return /* @__PURE__ */ jsx(Element, {
		...rest,
		className: cx("ds-inline", `ds-layout--align-${align}`, `ds-layout--justify-${justify}`, !wrap && "ds-inline--nowrap", className),
		style: {
			columnGap: spaceVar(gap),
			rowGap: spaceVar(rowGap ?? gap),
			...style
		}
	});
}
/** A child of an Inline that fills the rest of the row (`grow`). */
function InlineItem({ grow = false, as: Element = "div", className, ...rest }) {
	return /* @__PURE__ */ jsx(Element, {
		...rest,
		className: cx("ds-inline__item", grow && "ds-inline__item--grow", className)
	});
}
var BREAKPOINTS = [
	"base",
	"sm",
	"md",
	"lg"
];
/** Whole counts of at least 1 for every breakpoint, each inheriting the one below. */
function perBreakpoint(value, name) {
	const counts = typeof value === "number" ? { base: value } : value;
	const vars = {};
	let current = 1;
	for (const bp of BREAKPOINTS) {
		const count = counts[bp];
		if (count !== void 0 && Number.isFinite(count)) current = Math.max(1, Math.floor(count));
		vars[`--_${name}-${bp}`] = current;
	}
	return vars;
}
/**
* Children in a grid of equal columns, a token gap apart: as many as fit (`auto`), a
* fixed count, a count per breakpoint, or the 4/8/12-column layout grid.
*/
function Grid({ columns = "auto", minColumnWidth = "md", gap, align = "stretch", as: Element = "div", className, style, ...rest }) {
	const mode = columns === "auto" || columns === "layout" ? columns : "fixed";
	return /* @__PURE__ */ jsx(Element, {
		...rest,
		className: cx("ds-grid", `ds-grid--${mode}`, mode === "auto" && `ds-grid--min-${minColumnWidth}`, align !== "stretch" && `ds-grid--align-${align}`, className),
		style: {
			...mode === "fixed" && perBreakpoint(columns, "columns"),
			gap: spaceVar(gap),
			...style
		}
	});
}
/** A Grid cell that spans more than one column, e.g. 4 of the layout grid's 12. */
function GridItem({ span = 1, as: Element = "div", className, style, ...rest }) {
	return /* @__PURE__ */ jsx(Element, {
		...rest,
		className: cx("ds-grid__item", span === "full" && "ds-grid__item--full", className),
		style: {
			...span !== "full" && perBreakpoint(span, "span"),
			...style
		}
	});
}
//#endregion
export { Grid, GridItem, Inline, InlineItem, Stack };

//# sourceMappingURL=Layout.js.map